import Layout from "../../../components/org/Layout";
import { Subdomain } from "../../../utils/subdomain/subdomain";
import { Container, Grid, Typography } from "@mui/material";
import { GetServerSidePropsContext, InferGetServerSidePropsType } from "next";
import { flow, pipe } from "fp-ts/function";
import { index } from "../../../routes/org";
import { array, either, readonlyArray, task, taskEither } from "fp-ts";
import { sequenceS } from "fp-ts/Apply";
import { pick, runTask } from "../../../utils/fp";
import { newsFields } from "../../../domain/news";
import { validIsoDateStringCodec } from "../../../domain/common";
import * as t from "io-ts";
import { executeSupabaseQuery } from "../../../utils/supabase/useQuery";
import { columns } from "../../../utils/pg-ts/pg-ts";
import { supabase } from "../../../utils/supabase/init";
import { serializeMdx } from "../../../utils/mdx/serializeMdx";
import * as React from "react";
import { NewsCard } from "../../../components/org/NewsCard";

const subdomain = "jesenickysnek" as Subdomain;
const latestNewsFields = pipe(newsFields, pick("id", "content"), (fields) => ({
    ...fields,
    published: validIsoDateStringCodec, // TODO pg-ts untyped
}));
const latestNewsCodec = t.type(latestNewsFields);

const news = (orgSubdomain: Subdomain) =>
    pipe(
        executeSupabaseQuery(
            "latestNews",
            t.array(latestNewsCodec),
            (supabase) =>
                supabase
                    .from("news_published") // TODO pg-ts
                    .select(columns(latestNewsFields))
                    .eq("subdomain", orgSubdomain)
                    .order("published", { ascending: false }),
            supabase
        ),
        taskEither.chainW(
            flow(
                array.map((news) =>
                    pipe(
                        news.content,
                        serializeMdx,
                        taskEither.map((mdxContent) => ({
                            ...news,
                            mdxContent,
                        }))
                    )
                ),
                taskEither.sequenceArray
            )
        )
    );

export const getServerSideProps = async (context: GetServerSidePropsContext) =>
    pipe(
        context.params,
        index.queryCodec.decode,
        taskEither.fromEither,
        taskEither.chainW((query) =>
            sequenceS(taskEither.ApplyPar)({
                subdomain: taskEither.right(query.subdomain), // TODO learn the fp way to add context
                news: news(query.subdomain),
            })
        ),
        task.map(
            either.foldW(
                (e) => {
                    return {
                        notFound: true as const, // as const have to be here :/
                    };
                },
                (props) => {
                    return {
                        props,
                    };
                }
            )
        ),
        runTask
    );

// TODO pagination
export default (p: InferGetServerSidePropsType<typeof getServerSideProps>) => {
    return (
        <Layout
            subdomain={subdomain}
            seo={{ title: "Aktuality - Jesenický šnek" }}
        >
            <Container maxWidth={"md"}>
                <Typography variant={"h4"} component={"h1"} gutterBottom>
                    Archiv aktualit
                </Typography>
                <Grid container direction={"column"} spacing={2}>
                    {pipe(
                        p.news,
                        readonlyArray.toArray,
                        array.map((news) => (
                            <NewsCard key={news.id} {...news} />
                        ))
                    )}
                </Grid>
            </Container>
        </Layout>
    );
};
